import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
export function CraftSection() {
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-31">
      {/* Parallax Background */}
      <div className="absolute inset-0 bg-cover bg-center parallax-bg" style={{
      backgroundImage: 'url("https://assets.modern-commerce.io/Glenlofty%20Project%20Files/DJI_0263.jpg")'
    }} data-id="element-32" />
      {/* Heavy Overlay */}
      <div className="absolute inset-0 bg-black/70" data-id="element-33" />

      <div className="relative z-10 px-6 md:px-12 text-center max-w-4xl mx-auto" data-id="element-34">
        <ScrollReveal data-id="element-35">
          <span className="block text-gold text-sm font-light tracking-widest uppercase mb-8" data-id="element-36">
            The Craft
          </span>
        </ScrollReveal>

        <ScrollReveal delay={0.2} data-id="element-37">
          <h2 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-12 tracking-tight" data-id="element-38">
            HANDCRAFTED
            <br data-id="element-39" />
            EXCELLENCE
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.3} data-id="element-40">
          <div className="w-32 h-1 bg-gold mx-auto mb-12" data-id="element-41"></div>
        </ScrollReveal>

        <ScrollReveal delay={0.4} data-id="element-42">
          <p className="text-xl md:text-3xl text-gray-200 font-light leading-relaxed opacity-90" data-id="element-43">
            In the winery, our approach is one of minimal intervention.
            Traditional, artisanal techniques guide the wines from grape to
            glass, allowing the vineyard to speak clearly. Wild fermentations,
            gentle handling, and maturation in fine French oak contribute to
            wines of elegance, complexity, and longevity.
          </p>
        </ScrollReveal>
      </div>
    </section>;
}